import { useTranslation } from 'react-i18next'
import styles from './MiddleText.module.less'
import cls from 'classnames'

interface Props {
  text: string
  className?: string
  style?: React.CSSProperties
}

/** NOTE:这个组件是为了解决中文字体在 mac 和 window 上都会偏上，从而导致和相邻的 icon 对不齐的问题 */
function MiddleText({ text, className, style }: Props) {
  const { i18n } = useTranslation()
  return (
    <span className={cls(className, { [styles.middleText]: i18n.language === 'zh' })} style={style}>
      {text}
    </span>
  )
}

export default MiddleText
